'use client';

import dynamic from 'next/dynamic';

const IncrementalPriceGraph = dynamic(() => import('./IncrementalPriceGraph'));

const IncrementalPriceGraphWrapper = ({ bondID }: any) => {
    return <IncrementalPriceGraph bondID={bondID} />;
};

export default IncrementalPriceGraphWrapper;
